import React from 'react';
import styles from './history-detail/HistoryDetailView.module.css';
import { ArrowLeftIcon } from '../../components/Icons';

const HistoryDetailView = ({ title, onBack, children }) => {
  return (
    <div className={styles.detailView}>
      <div className={styles.detailHeader}>
        <button
          type="button"
          className={styles.backButton}
          onClick={onBack}
          aria-label="返回"
        >
          <ArrowLeftIcon size={20} />
        </button>
        {title && <div className={styles.detailTitle}>{title}</div>}
      </div>
      <div className={styles.detailContent}>{children}</div>
    </div>
  );
};

export default HistoryDetailView;

